module.exports = __webpack_public_path__ + "static/media/phone@2x.a5c963c7.png";